module.exports = __webpack_public_path__ + "static/media/rocket_black.13d14bad.svg";